<template>
  <div class="mx-3 mt-3">
    <!-- ENCABEZADO -->
    <div class="bg-white rounded-3 p-4 mb-4 border shadow-sm">
      <div class="d-flex align-items-center mb-2">
        <i class="bi bi-boxes text-primary me-3 fs-2"></i>
        <div>
          <h4 class="fw-bold text-primary mb-1">ACCESO</h4>
          <p class="fw-semibold text-secondary mb-0">Asignación de Centro de Costos</p>
        </div>
      </div>
    </div>

    <!-- LEYENDA -->
    <div class="bg-white rounded-3 p-4 mb-4 border shadow-sm">
      <div class="d-flex align-items-center mb-3">
        <i class="bi bi-info-circle-fill text-primary me-2 fs-5"></i>
        <h6 class="fw-bold text-secondary mb-0">Leyenda</h6>
      </div>

      <div class="d-flex flex-wrap gap-4 ms-1">
        <div class="d-flex align-items-center">
          <i class="bi bi-check-circle-fill text-primary me-2 fs-5"></i>
          <span class="fw-semibold text-dark">Habilitado</span>
        </div>

        <div class="d-flex align-items-center">
          <i class="bi bi-x-circle-fill text-dark me-2 fs-5"></i>
          <span class="fw-semibold text-dark">Deshabilitado</span>
        </div>
      </div>
    </div>

    <!-- SELECTOR -->
    <div class="mb-4">
      <label class="form-label fw-semibold text-secondary">
        <i class="bi bi-person-badge me-2"></i>SELECCIONAR TRABAJADOR:
      </label>
      <select @change="DocumentoParams($event)" class="form-select shadow-sm">
        <option selected disabled>SELECCIONA DNI</option>
        <option v-for="documentoIdentidad in trabajadores" :key="documentoIdentidad.id"
          :value="documentoIdentidad.trabNroDoi">
          {{ documentoIdentidad.nombre }}
        </option>
      </select>
    </div>

    <!-- LISTADO -->
    <div class="row g-3">
      <!-- EMPRESA -->
      <div v-if="modificarCentro" class="col-12 col-md-3">
        <h6 class="text-uppercase text-secondary fw-semibold mb-2">
          <i class="bi bi-building me-2"></i> EMPRESA
        </h6>

        <div v-for="emp in empresa" :key="emp.id" :class="[
          'card p-2 mb-2 shadow-sm border-2 hover-card cursor-pointer',
          { 'border-primary bg-light': empresaValor == emp.id }
        ]" @click="CentroCostos(emp.id)">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold text-dark">{{ emp.empNomCorto }}</span>


            <div class="d-flex align-items-center gap-2">
              <!-- Registrar -->
              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': emp.registrar == true,
                'text-black': emp.registrar == false,
              }" title="Editar acceso" @click="Empresa(emp.registrar, emp.idTrab, emp.id)"></i>

              <!-- Visualizar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                :class="{
                  'text-primary': emp.visualizar == true,
                  'text-black': emp.visualizar == false,
                }" viewBox="0 0 16 16" title="Visualizar acceso"
                @click="EmpresaVisualizar(emp.visualizar, emp.idTrab, emp.id, emp)">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 
      5.5-8 5.5S0 8 0 8zm8 
      3.5a3.5 3.5 0 1 0 0-7 
      3.5 3.5 0 0 0 0 7z" />
              </svg>
              <!-- Separador -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-dash-lg"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 
      1 .5-.5h11a.5.5 0 0 
      1 0 1h-11A.5.5 0 0 
      1 2 8Z" transform="rotate(90 8 8)" />
              </svg>

              <!-- Registrar -->
              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': emp.conRegistrar == true,
                'text-black': emp.conRegistrar == false,
              }" title="Registrar acceso" @click="EmpresaRegistrarCon(emp.conRegistrar, emp.idTrab, emp.id)"></i>
              
              <!-- Visualizar (conRegistrar) -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                :class="{
                  'text-primary': emp.conVisualizar == true,
                  'text-black': emp.conVisualizar == false,
                }" viewBox="0 0 16 16" title="Visualizar acceso"
                @click="EmpresaVisualizarCon(emp.conVisualizar, emp.idTrab, emp.id)">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 
      5.5-8 5.5S0 8 0 8zm8 
      3.5a3.5 3.5 0 1 0 0-7 
      3.5 3.5 0 0 0 0 7z" />
              </svg>
            </div>

          </div>
        </div>
      </div>

      <!-- CENTRO DE COSTOS -->
      <div v-if="centro" class="col-12 col-md-3">
        <h6 class="text-uppercase text-secondary fw-semibold mb-2">
          <i class="bi bi-diagram-3 me-2"></i> Centro de Costos 
        </h6>
        <div v-for="centro in CentroDeCosto" :key="centro.id" :class="[
          'card p-2 mb-2 shadow-sm border-2 hover-card cursor-pointer',
          { 'border-primary bg-light': centroCostosValor == centro.idCentro }
        ]" @click="SubCentroCostos(centro.idCentro, centro.cenCodigo)">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold text-dark">{{ centro.cenNombre }}</span>

            <div class="d-flex align-items-center gap-2">

              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': centro.registrar == true,
                'text-black': centro.registrar == false,
              }" title="Editar" @click="
                EliminarCosto(
                  centro.registrar,
                  centro.idTrab,
                  centro.cenCodigo
                )
                "></i>

              <!-- Visualizar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                viewBox="0 0 16 16" @click="
                  EliminarCostoVisualizar(
                    centro.visualizar,
                    centro.idTrab,
                    centro.cenCodigo
                  )
                  " :class="{
                    'text-primary': centro.visualizar == true,
                    'text-black': centro.visualizar == false,
                  }" title="Visualizar">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
      16 8s-3 5.5-8 5.5S0 8 
      0 8zm8 3.5a3.5 3.5 0 1 
      0 0-7 3.5 3.5 0 0 0 0 
      7z" />
              </svg> 

              <!-- Separador -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-dash-lg"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 
      1 .5-.5h11a.5.5 0 0 
      1 0 1h-11A.5.5 0 0 
      1 2 8Z" transform="rotate(90 8 8)" />
              </svg>

              <!-- Registrar -->
              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': centro.conRegistrar == true,
                'text-black': centro.conRegistrar == false,
              }" title="Registrar" @click="
                EliminarCostoCon(
                  centro.conRegistrar,
                  centro.idTrab,
                  centro.cenCodigo
                )
                "></i>

              <!-- Visualizar conexión -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                viewBox="0 0 16 16" @click="
                  EliminarCostoVisualizarCon(
                    centro.conVisualizar,
                    centro.idTrab,
                    centro.cenCodigo
                  )
                  " :class="{
                    'text-primary': centro.conVisualizar == true,
                    'text-black': centro.conVisualizar == false,
                  }" title="Visualizar conexión">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
      16 8s-3 5.5-8 5.5S0 8 
      0 8zm8 3.5a3.5 3.5 0 1 
      0 0-7 3.5 3.5 0 0 0 0 
      7z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- SUBCENTRO -->
      <div v-if="subCentro" class="col-12 col-md-3">
        <h6 class="text-uppercase text-secondary fw-semibold mb-2">
          <i class="bi bi-diagram-2 me-2"></i> Subcentro (PROYECTOS)
        </h6>
        <div v-for="sub in subCentroDeCostos" :key="sub.id" :class="[
          'card p-2 mb-2 shadow-sm border-2 hover-card cursor-pointer',
          { 'border-primary bg-light': subCentroCostosValor == sub.id }
        ]" @click="SubSubCentroCostos(sub.id, sub.cenSubCentro)">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold text-dark">{{ sub.cenNombre }}</span>

            <div class="d-flex align-items-center gap-2">
              <!-- Registrar -->
              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': sub.registrar == true,
                'text-black': sub.registrar == false,
              }" title="Registrar" @click="EliminarSubCentro(sub.registrar, sub.idTrab)"></i> 
        
              <!-- Visualizar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                viewBox="0 0 16 16" :class="{
                  'text-primary': sub.visualizar == true,
                  'text-black': sub.visualizar == false,
                }" title="Visualizar" @click="EliminarSubCentroVisualizar(sub.visualizar, sub.idTrab)">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
      16 8s-3 5.5-8 5.5S0 8 
      0 8zm8 3.5a3.5 3.5 0 1 
      0 0-7 3.5 3.5 0 0 0 0 
      7z" />
              </svg>

              <!-- Separador -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-dash-lg"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 
      1 .5-.5h11a.5.5 0 0 
      1 0 1h-11A.5.5 0 0 
      1 2 8Z" transform="rotate(90 8 8)" />
              </svg>

              <!-- Registrar conexión -->
              <i class="bi bi-pencil-square fs-5" :class="{
                'text-primary': sub.conRegistrar == true,
                'text-black': sub.conRegistrar == false,
              }" title="Registrar conexión" @click="EliminarSubCentroCon(sub.conRegistrar, sub.idTrab)"></i>
          
              <!-- Visualizar conexión -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-eye-fill"
                viewBox="0 0 16 16" :class="{
                  'text-primary': sub.conVisualizar == true,
                  'text-black': sub.conVisualizar == false,
                }" title="Visualizar conexión" @click="EliminarSubCentroVisualizarCon(sub.conVisualizar, sub.idTrab)">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
      16 8s-3 5.5-8 5.5S0 8 
      0 8zm8 3.5a3.5 3.5 0 1 
      0 0-7 3.5 3.5 0 0 0 0 
      7z" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- SUBSUBCENTRO -->
      <div v-if="subSubCentro" class="col-12 col-md-3">
        <h6 class="text-uppercase text-secondary fw-semibold mb-2">
          <i class="bi bi-diagram-2-fill me-2"></i> Subsubcentro (CANAL)
        </h6>
        <div v-for="subsub in subSubCentroDeCostos" :key="subsub.id" :class="[
          'card p-2 mb-2 shadow-sm border-2 hover-card cursor-pointer',
          { 'border-primary bg-light': subSubCentroCostosValor == subsub.id }
        ]">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold fs-6  text-dark">{{ subsub.cenSubSubNombre }}</span>

            <div class="d-flex align-items-center gap-2">
              <!-- Registrar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-pencil-square fs-5" viewBox="0 0 16 16"
                @click="EliminarSubSubCentro(subsub.idTrab, subsub.registrar)" :class="{
                  'text-primary': subsub.registrar == true,
                  'text-black': subsub.registrar == false,
                }">
                <path d="M15.502 1.94a.5.5 0 0 1 0 
         .706l-1 1a.5.5 0 0 1-.707 
         0L13 2.207l1-1a.5.5 0 0 
         1 .707 0l.795.733zM13.5 
         3.207L6 10.707V13h2.293l7.5-7.5L13.5 
         3.207z" />
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 
         15h11a1.5 1.5 0 0 0 
         1.5-1.5v-6a.5.5 0 0 0-1 
         0v6a.5.5 0 0 1-.5.5h-11a.5.5 
         0 0 1-.5-.5v-11a.5.5 0 0 
         1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 
         1.5 0 0 0 1 2.5v11z" />
              </svg>

              <!-- Visualizar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-eye-fill fs-5" viewBox="0 0 16 16"
                @click="EliminarSubSubCentroVisualizar(subsub.idTrab, subsub.visualizar)" :class="{
                  'text-primary': subsub.visualizar == true,
                  'text-black': subsub.visualizar == false,
                }">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
         16 8s-3 5.5-8 5.5S0 8 
         0 8zm8 3.5a3.5 3.5 0 1 0 
         0-7 3.5 3.5 0 0 0 0 7z" />
              </svg>
              <!-- División -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-dash-lg"
                viewBox="0 0 16 16" style="transform: rotate(90deg); transform-origin: center">
                <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 
         0 0 1 0 1h-11A.5.5 0 0 1 2 8Z" />
              </svg>

              <!-- Editar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-pencil-square fs-5" viewBox="0 0 16 16"
                @click="EliminarSubSubCentroCon(subsub.idTrab, subsub.conRegistrar)" :class="{
                  'text-primary': subsub.conRegistrar == true,
                  'text-black': subsub.conRegistrar == false,
                }">
                <path d="M15.502 1.94a.5.5 0 0 1 0 
         .706l-1 1a.5.5 0 0 1-.707 
         0L13 2.207l1-1a.5.5 0 0 
         1 .707 0l.795.733zM13.5 
         3.207L6 10.707V13h2.293l7.5-7.5L13.5 
         3.207z" />
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 
         15h11a1.5 1.5 0 0 0 
         1.5-1.5v-6a.5.5 0 0 0-1 
         0v6a.5.5 0 0 1-.5.5h-11a.5.5 
         0 0 1-.5-.5v-11a.5.5 0 0 
         1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 
         1.5 0 0 0 1 2.5v11z" />
              </svg>

              <!-- Visualizar -->
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                class="bi bi-eye-fill fs-5" viewBox="0 0 16 16"
                @click="EliminarSubSubCentroVisualizarCon(subsub.idTrab, subsub.conVisualizar)" :class="{
                  'text-primary': subsub.conVisualizar == true,
                  'text-black': subsub.conVisualizar == false,
                }">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path d="M0 8s3-5.5 8-5.5S16 8 
         16 8s-3 5.5-8 5.5S0 8 
         0 8zm8 3.5a3.5 3.5 0 1 0 
         0-7 3.5 3.5 0 0 0 0 7z" />
              </svg>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "SolimanologAccesosRegistrar",

  data() {
    return {
      empresa: [],
      CentroDeCosto: [],
      subCentroDeCostos: [],
      subSubCentroDeCostos: [],
      empresaValor: "",
      centroCostosValor: "",
      subCentroCostosValor: "",
      subSubCentroCostosValor: "",
      codCentroCosto: "",
      codSubCentroCosto: "",
      centro: false,
      subCentro: false,
      subSubCentro: false,
      modificarCentro: true,
      // EliminarCentro: false,
      LimpiarEpresa: [],
      limpiarCentroCosto: [],
      limpiarSubCentroCosto: [],

      dniUsuarios: "",
      trabajadores: [],
    };
  },

  mounted() {
    this.axios.get(`TrabAcceso/ObtenerDocumentosDeIdentidad`).then((r) => {
      console.log(r.data);
      this.trabajadores = r.data;
    });
  },

  created() {
    this.cambiarEstadoNavbar();

  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
    DocumentoParams(event) {
      this.dniUsuarios = event.target.value;
      this.getAttributes();
      this.CentroDeCosto = [];
      this.subCentroDeCostos = [];
      this.subSubCentroDeCostos = [];
    },
    actualizarLista(enter) {
      console.log(enter);
      this.getAttributes();
    },
    getAttributes() {
      this.axios.get(`Empresa/EmpresaAcceso/${this.dniUsuarios}`).then((r) => {
        this.empresa = r.data;
        console.log(r.data);
      });
    },
    CentroCostos(idEmpresa) {
      this.centro = false
      this.subSubCentro = false
      this.empresaValor = idEmpresa;
      console.log(this.empresaValor);
      this.axios
        .get(
          `Ccosto/CcxTrabajdorAcceso?idEmpresa=${idEmpresa}&dniUser=${this.dniUsuarios}`
        )
        .then((r) => {
          this.CentroDeCosto = r.data;
          this.centro = true;
          this.subCentro = false;
          this.subSubCentro = false;
          console.log('r config' ,r.data);
        });
    },

    SubCentroCostos(idCentro, cenCodigo) {
      this.subSubCentro = false
      this.centroCostosValor = idCentro;
      this.codCentroCosto = cenCodigo;
      this.axios
        .get(
          `SubCentro/AccesoScxTrabajador?codCenCosto=${cenCodigo}&dniUser=${this.dniUsuarios}&idEmpresa=${this.empresaValor}`
        )
        .then((r) => {
          this.subCentroDeCostos = r.data;
          this.subCentro = true;
          this.subSubCentro = false;
          console.log(r.data);
        });
    },

    SubSubCentroCostos(id, cenCodigo) {
      this.subCentroCostosValor = id;
      this.codSubCentroCosto = cenCodigo;
      console.log(cenCodigo);
      this.axios
        .get(
          `SubSubCentro/AccesoSscxTrabajador?idEmpresa=${this.empresaValor}&dniUser=${this.dniUsuarios}&codCentro=${this.codCentroCosto}&codSubCentro=${cenCodigo}`
        )
        .then((r) => {
          console.log(r.data);
          this.subSubCentroDeCostos = r.data;
          this.subSubCentro = true;
        });
    },

    Empresa(visualizar, id, idEmpresa) {
      console.log(visualizar);
      console.log(id);
      if (visualizar == true) {
        this.axios
          .get(
            `Empresa/ListaIds?idEmpresa=${idEmpresa}&Dni=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r);

            for (let index of r.data) {
              this.LimpiarEpresa.push(index.id);
              console.log(this.LimpiarEpresa);
              if (r.data.length == this.LimpiarEpresa.length) {
                const from = {
                  id: `${this.LimpiarEpresa},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarTrabAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(idEmpresa);
                    this.LimpiarEpresa = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarTrabAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(idEmpresa);
          this.LimpiarEpresa = [];
        });
      }
    },

    EmpresaVisualizar(visualizar, id, idEmpresa, empre) {
      console.log(visualizar);
      console.log(id, empre);
      if (visualizar == true) {
        this.axios
          .get(
            `Empresa/ListaIdsVisual?idEmpresa=${idEmpresa}&Dni=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);

            for (let index of r.data) {
              this.LimpiarEpresa.push(index.idTrab);
              console.log(this.LimpiarEpresa);
              if (r.data.length == this.LimpiarEpresa.length) {
                const from = {
                  id: `${this.LimpiarEpresa},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(from);
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(idEmpresa);
                    this.LimpiarEpresa = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(idEmpresa);
          this.LimpiarEpresa = [];
        });
      }
    },

    EmpresaRegistrarCon(visualizar, id, idEmpresa) {
      console.log(visualizar);
      console.log(id);
      if (visualizar == true) {
        this.axios
          .get(
            `Empresa/ListaIds?idEmpresa=${idEmpresa}&Dni=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r);

            for (let index of r.data) {
              this.LimpiarEpresa.push(index.id);
              console.log(this.LimpiarEpresa);
              if (r.data.length == this.LimpiarEpresa.length) {
                const from = {
                  id: `${this.LimpiarEpresa},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
                  console.log(r.data);
                  this.getAttributes();
                  this.CentroCostos(idEmpresa);                
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );
                    this.CentroDeCosto = []
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(idEmpresa);
          this.LimpiarEpresa = [];
          this.limpiarCentroCosto = [];

        });
      }
    },

    EmpresaVisualizarCon(visualizar, id, idEmpresa) {
      console.log('tomalo',visualizar, id ,idEmpresa);
      if (visualizar == true) {
        this.axios
          .get(
            `Empresa/ListaIds?idEmpresa=${idEmpresa}&Dni=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log("que pasa aqui",r.data);

            for (let index of r.data) {
              this.LimpiarEpresa.push(index.id);
              console.log(this.LimpiarEpresa);
              if (r.data.length == this.LimpiarEpresa.length) {
                const from = {
                  id: `${this.LimpiarEpresa},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarConVisu`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(idEmpresa);
                    this.LimpiarEpresa = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConVisu`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(idEmpresa);
          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarCosto(visualizar, id, cenCodigo) {
      console.log(visualizar, id);

      if (visualizar == true) {
        this.axios
          .get(
            `Ccosto/IdsTrabCcosto?idEmpresa=${this.empresaValor}&codCcosto=${cenCodigo}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarCentroCosto.push(index.idTrab);

              if (r.data.length == this.limpiarCentroCosto.length) {
                const from = {
                  id: `${this.limpiarCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarTrabAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(this.empresaValor);
                    // this.SubSubCentroCostos(
                    //   this.subCentroCostosValor,
                    //   this.codSubCentroCosto
                    // );
                    this.subSubCentro = false
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarTrabAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(this.empresaValor);
          // this.SubSubCentroCostos(
          //   this.subCentroCostosValor,
          //   this.codSubCentroCosto
          // );
          this.subSubCentro = false
          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarCostoVisualizar(visualizar, id, cenCodigo) {
      console.log(visualizar, id);

      if (visualizar == true) {
        this.axios
          .get(
            `Ccosto/IdsTrabCcostoVisual?idEmpresa=${this.empresaValor}&codCcosto=${cenCodigo}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarCentroCosto.push(index.idTrab);

              if (r.data.length == this.limpiarCentroCosto.length) {
                const from = {
                  id: `${this.limpiarCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(this.empresaValor);
                    // this.SubSubCentroCostos(
                    //   this.subCentroCostosValor,
                    //   this.codSubCentroCosto
                    // );
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                    this.subSubCentro = false

                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(this.empresaValor);
          // this.SubSubCentroCostos(
          //   this.subCentroCostosValor,
          //   this.codSubCentroCosto
          // );
          this.LimpiarEpresa = [];
          this.subSubCentro = false

        });
      }
    },

    EliminarCostoCon(visualizar, id, cenCodigo) {
      console.log(visualizar, id);

      if (visualizar == true) {
        this.axios
          .get(
            `Ccosto/IdsTrabCcosto?idEmpresa=${this.empresaValor}&codCcosto=${cenCodigo}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarCentroCosto.push(index.idTrab);

              if (r.data.length == this.limpiarCentroCosto.length) {
                const from = {
                  id: `${this.limpiarCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarConReg`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(this.empresaValor);
                    // this.SubSubCentroCostos(
                    //   this.subCentroCostosValor,
                    //   this.codSubCentroCosto
                    // );
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(this.empresaValor);
          // this.SubSubCentroCostos(
          //   this.subCentroCostosValor,
          //   this.codSubCentroCosto
          // );

          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarCostoVisualizarCon(visualizar, id, cenCodigo) {
      console.log('aqui' , visualizar, id);

      if (visualizar == true) {
        this.axios
          .get(
            `Ccosto/IdsTrabCcostoVisual?idEmpresa=${this.empresaValor}&codCcosto=${cenCodigo}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarCentroCosto.push(index.idTrab);

              if (r.data.length == this.limpiarCentroCosto.length) {
                const from = {
                  id: `${this.limpiarCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarConVisu`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.CentroCostos(this.empresaValor);
                    // this.SubSubCentroCostos(
                    //   this.subCentroCostosValor,
                    //   this.codSubCentroCosto
                    // );
                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConVisu`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.CentroCostos(this.empresaValor);
          // this.SubSubCentroCostos(
          //   this.subCentroCostosValor,
          //   this.codSubCentroCosto
          // );

          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarSubCentro(visualizar, id) {
      console.log(visualizar, id);
      console.log(
        this.empresaValor,
        this.codCentroCosto,
        this.codSubCentroCosto,
        this.dniUsuarios
      );
      if (visualizar == true) {
        this.axios
          .get(
            `SubCentro/idsSccxTrab?idEmpresa=${this.empresaValor}&codCenCosto=${this.codCentroCosto}&codScc=${this.codSubCentroCosto}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
                      console.log("llego")

            console.log(r.data);
            for (let index of r.data) {
              this.limpiarSubCentroCosto.push(index.idTrab);
              if (r.data.length == this.limpiarSubCentroCosto.length) {
                const from = {
                  id: `${this.limpiarSubCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log('form',from);
                this.axios
                  .put(`TrabAcceso/ModificarTrabAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.SubCentroCostos(
                      this.centroCostosValor,
                      this.codCentroCosto
                    );
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );

                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                     this.limpiarSubCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarTrabAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubCentroCostos(this.centroCostosValor, this.codCentroCosto);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      //
    },
    EliminarSubCentroVisualizar(visualizar, id) {
      console.log(visualizar, id , this.empresaValor ,this.codCentroCosto , this.codSubCentroCosto , this.dniUsuarios)
      if (visualizar == true) {
        this.axios
          .get(
            `SubCentro/idsSccxTrabVisual?idEmpresa=${this.empresaValor}&codCenCosto=${this.codCentroCosto}&codScc=${this.codSubCentroCosto}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarSubCentroCosto.push(index.idTrab);
              if (r.data.length == this.limpiarSubCentroCosto.length) {
                const from = {
                  id: `${this.limpiarSubCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarVisualbAcceso`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.SubCentroCostos(
                      this.centroCostosValor,
                      this.codCentroCosto
                    );
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );

                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                     this.limpiarSubCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubCentroCostos(this.centroCostosValor, this.codCentroCosto);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
       this.limpiarSubCentroCosto = [];

        });
      }

      //
    },

    EliminarSubCentroCon(visualizar, id) {
      if (visualizar == true) {
        this.axios
          .get(
            `SubCentro/idsSccxTrab?idEmpresa=${this.empresaValor}&codCenCosto=${this.codCentroCosto}&codScc=${this.codSubCentroCosto}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarSubCentroCosto.push(index.idTrab);
              if (r.data.length == this.limpiarSubCentroCosto.length) {
                const from = {
                  id: `${this.limpiarSubCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                console.log(from);
                this.axios
                  .put(`TrabAcceso/ModificarConReg`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.SubCentroCostos(
                      this.centroCostosValor,
                      this.codCentroCosto
                    );
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );

                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                    this.limpiarSubCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubCentroCostos(this.centroCostosValor, this.codCentroCosto);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }
    },

    EliminarSubCentroVisualizarCon(visualizar, id) {
      if (visualizar == true) {
        this.axios
          .get(
            `SubCentro/idsSccxTrabVisual?idEmpresa=${this.empresaValor}&codCenCosto=${this.codCentroCosto}&codScc=${this.codSubCentroCosto}&dniUser=${this.dniUsuarios}`
          )
          .then((r) => {
            console.log(this.empresaValor, this.codCentroCosto, this, this.codSubCentroCosto, this.dniUsuarios)
            console.log(r.data);
            for (let index of r.data) {
              this.limpiarSubCentroCosto.push(index.idTrab);
              if (r.data.length == this.limpiarSubCentroCosto.length) {
                const from = {
                  id: `${this.limpiarSubCentroCosto},`,
                  trabNroDoi: `${this.dniUsuarios}`,
                };

                this.axios
                  .put(`TrabAcceso/ModificarConVisu`, from)
                  .then((r) => {
                    console.log(r.data);
                    this.getAttributes();
                    this.SubCentroCostos(
                      this.centroCostosValor,
                      this.codCentroCosto
                    );
                    this.SubSubCentroCostos(
                      this.subCentroCostosValor,
                      this.codSubCentroCosto
                    );

                    this.LimpiarEpresa = [];
                    this.limpiarCentroCosto = [];
                    this.limpiarSubCentroCosto = [];
                  });
              }
            }
          });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        this.axios.put(`TrabAcceso/ModificarConVisu`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubCentroCostos(this.centroCostosValor, this.codCentroCosto);
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

    },

    EliminarSubSubCentro(id, visualizar) {
      console.log(visualizar);
      if (visualizar == true) {
        const from = {
          id: `${id},`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarTrabAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarTrabAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      //
    },

    EliminarSubSubCentroVisualizar(id, visualizar) {
      console.log(visualizar);
      if (visualizar == true) {
        const from = {
          id: `${id},`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarVisualbAcceso`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      //
    },

    EliminarSubSubCentroCon(id, visualizar) {
      if (visualizar == true) {
        const from = {
          id: `${id},`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConReg`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

    },

    EliminarSubSubCentroVisualizarCon(id, visualizar) {
      if (visualizar == true) {
        const from = {
          id: `${id},`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConVisu`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();
          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }

      if (visualizar == false) {
        const from = {
          id: `${id}`,
          trabNroDoi: `${this.dniUsuarios}`,
        };

        console.log(from);

        this.axios.put(`TrabAcceso/ModificarConVisu`, from).then((r) => {
          console.log(r.data);
          this.getAttributes();

          this.SubSubCentroCostos(
            this.subCentroCostosValor,
            this.codSubCentroCosto
          );

          this.limpiarSubCentroCosto = [];
          this.LimpiarEpresa = [];
        });
      }
    }

    //
    // Eliminar() {
    //   // this.EliminarCentro = true;
    //   // this.modificarCentro = false;

    //   this.$router.push("/accesoVisualizacion");
    // },
  },
};
</script>

<style scoped>
.bg-cajita {
  background: rgb(227, 227, 242);
}

.cursor {
  cursor: pointer;
}

.tamaño {
  font-size: 0.65rem;
}

.custom-button {
  background-color: #ff3366;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

.custom-input {
  display: flex;
}

.custom-input__input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
  width: 100%;
}

.custom-input__input:focus {
  outline: none;
  border-color: #5696f7;
  box-shadow: 0 0 5px rgba(236, 229, 231, 0.5);
}

.texto-peque {
  font-size: 0.65rem;
  text-align: left;
}

input[type="number"] {
  border: 2px solid #ccc;
  border-radius: 5px;
  padding: 8px;
  font-size: 16px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
</style>
